export default {
    account_api_keys_tab_name: 'Name',
    account_api_keys_tab_api_key: 'API Key',
    account_api_keys_tab_rate_limit_plan: 'Limit Rate Plan',
    account_api_keys_tab_rate_limit: 'Rate Limit',
    account_api_keys_tab_search_placeholder: 'Search by name',
    account_api_keys_tab_copy_error: 'Could not retrieve the api key value',
};
